export default class AutoCompleter {
  // @items is an array like [["match term 1", value], ["match term 2", value2]]
  constructor(items) {
    this.items = items;
  }

  try(text) {
    let match;
    const matches = this.allMatches(text);
    if ((match = matches[0])) {
      return {
        term: match[0],
        data: match[1],
        completionOffset: text.length,
        matches,
      };
    }
    return null;
  }

  shortestMatch(text) {
    return this.allMatches(text).sort((a, b) => a[0].length - b[0].length)[0];
  }

  allMatches(text) {
    if (!text || text.length === 0) {
      return [];
    }
    const pattern = new RegExp(`^${text}`, "i");
    return this.items.filter((i) => String(i[0]).match(pattern));
  }

  complete(data) {
    if (data && data.token) {
      const input = data.token.value();
      const match = this.try(input);
      if (!match) {
        if (data.noMatch) {
          data.noMatch(data.token);
        }
      } else if (match.term === input) {
        if (data.exactMatch) {
          data.exactMatch(data.token, match);
        }
      } else if (data.partialMatch) {
        data.partialMatch(
          data.token.cloneWithNewValue(match.term),
          match,
          match.matches,
        );
      }
    }
  }
}
